import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';
import { sortBy } from 'lodash';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_PAYMENT_PLANS = 'FETCH_PAYMENT_PLANS';
export const FETCH_PAYMENT_PLANS_SUCCESS = 'FETCH_PAYMENT_PLANS_SUCCESS';
export const FETCH_PAYMENT_PLANS_FAIL = 'FETCH_PAYMENT_PLANS_FAIL';
export const SELECT_PAYMENT_PLAN = 'SELECT_PAYMENT_PLAN';

// Reducer
export default function paymentPlansReducer(state = { data: [], loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PAYMENT_PLANS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PAYMENT_PLANS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PAYMENT_PLANS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPaymentPlans(payload) {
  return { type: FETCH_PAYMENT_PLANS, payload };
}

export function fetchPaymentPlansSuccess(payload) {
  return { type: FETCH_PAYMENT_PLANS_SUCCESS, payload };
}

export function fetchPaymentPlansFail(payload) {
  return { type: FETCH_PAYMENT_PLANS_FAIL, payload };
}

export function selectPaymentPlan(payload) {
  return { type: SELECT_PAYMENT_PLAN, payload };
}

// Requests
export function requestFetchPaymentPlans() {
  return callApi('stripe/product/?limit=10&offset=0');
}

export function requestSelectPaymentPlan(payload) {
  return callApi('stripe/payment/stripe_session/', 'POST', payload);
}

// Sagas
function* fetchPaymentPlansSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchPaymentPlans);
    yield put(fetchPaymentPlansSuccess({
      data: sortBy(res.data.map(item => ({
        ...item,
        'Full Description': item['Full Description'].replace('*', '').split('\r\n*'),
      })), 'Position'),
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchPaymentPlansFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* selectPaymentPlanSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestSelectPaymentPlan, values);
    // yield put(createInsuranceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    // yield put(addNotification({
    //   message: 'New Payer successfully added',
    //   variant: 'success',
    // }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    // yield put(createInsuranceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* paymentPlansSaga() {
  yield takeEvery(FETCH_PAYMENT_PLANS, fetchPaymentPlansSaga);
  yield takeEvery(SELECT_PAYMENT_PLAN, selectPaymentPlanSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/paymentPlans.js